import { Component, EventEmitter, OnDestroy, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EditDurationsService } from "../services/edit-durations.service";
import { finalize, takeUntil } from "rxjs/operators";
import { JiraService } from "../services/jira.service";

@Component({
    selector: "nx-edit-dialog",
    templateUrl: "./edit-timer-durations-dialog.component.html",
    styleUrls: ["./edit-timer-durations-dialog.component.scss"],
    standalone: false
})
export class EditTimerDurationsDialogComponent implements OnDestroy {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<EditTimerDurationsDialogComponent>>(MatDialogRef);
  editDurationsService = inject(EditDurationsService);
  jiraService = inject(JiraService);

  public durationsFormValid: boolean;
  private _destroyEmitter = new EventEmitter<void>();

  public isDurationFormValid(event): void {
    this.durationsFormValid = event;
  }

  public saveChanges(): void {
    this.jiraService.isLoading$.next(true);
    this.editDurationsService.saveChanges()
      .pipe(
        takeUntil(this._destroyEmitter),
        finalize(() => {
          this.dialogRef.close();
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.jiraService.isLoading$.next(false);
    this._destroyEmitter.next();
  }
}
